export default "__VITE_ASSET__CQYK922h__";